import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/loader/Loadable';
import Spinners from '../views/ui/Spinner';
import PrivateRoute from './PrivateRoute';
import DashboardRedirect from './DashboardRedirect';
import RedirectPerfilColaborador from './RedirectPerfilColaborador';

/****Layouts*****/
const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/BlankLayout')));
/***** Pages ****/

const Starter = Loadable(lazy(() => import('../views/Starter')));
const About = Loadable(lazy(() => import('../views/About')));
const Alerts = Loadable(lazy(() => import('../views/ui/Alerts')));
const Badges = Loadable(lazy(() => import('../views/ui/Badges')));
const Buttons = Loadable(lazy(() => import('../views/ui/Buttons')));
const Cards = Loadable(lazy(() => import('../views/ui/Cards')));
const Grid = Loadable(lazy(() => import('../views/ui/Grid')));
const Tables = Loadable(lazy(() => import('../views/ui/Tables')));
const Forms = Loadable(lazy(() => import('../views/ui/Forms')));
const Breadcrumbs = Loadable(lazy(() => import('../views/ui/Breadcrumbs')));

const NuevoColaborador = Loadable(lazy(() => import('../views/profile/Perfil/NuevoColaborador')));
const IngresoColaborador = Loadable(lazy(() => import('../views/profile/Perfil/IngresoColaborador')));
const SeguridadMS = Loadable(lazy(() => import('../views/profile/Perfil/SeguridadMS')));
const SeguridadShow = Loadable(lazy(() => import('../views/profile/employeeCenterDatos/SeguridadShow')));
const Colaborador = Loadable(lazy(() => import('../views/Colaborador')));


const FirmaElectronica = Loadable(lazy(() => import('../views/profile/Perfil/FirmaElectronica')));

/***** Auth Pages ****/
const Error = Loadable(lazy(() => import('../views/auth/Error')));
const Login = Loadable(lazy(() => import('../views/auth/Login')));
/*****Routes******/

const Ia_peech = Loadable(lazy(() => import('../views/app/ia_speech/ia_speech')));

const ThemeRoutes = [
  {
    path: '/',
    element: <Navigate to="/auth/login" />, // Redirige la raíz a la pagina principal
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '', element: <Navigate to="login" /> },
      { path: 'login', exact: true, element: <Login /> },
      { path: '*', element: <Navigate to="404" /> },
    ],
  },
  {
    path: '/app',
    element: <PrivateRoute />,
    children: [
      { index: true, element: <DashboardRedirect /> },
      { path: 'starter', exact: true, element: <Starter /> },
      { path: 'iaspeech', exact: true, element: <Ia_peech /> },
      { path: 'about', exact: true, element: <About /> },
      { path: 'ui/alerts', exact: true, element: <Alerts /> },
      { path: 'badges', exact: true, element: <Badges /> },
      { path: 'buttons', exact: true, element: <Buttons /> },
      { path: 'cards', exact: true, element: <Cards /> },
      { path: 'grid', exact: true, element: <Grid /> },
      { path: 'table', exact: true, element: <Tables /> },
      { path: 'forms', exact: true, element: <Forms /> },
      { path: 'breadcrumbs', exact: true, element: <Breadcrumbs /> },
    
      { path: 'Colaborador', element: <Navigate to="/app/Colaborador" /> },
      { path: 'Colaborador/:id', element: <Colaborador /> },
      { path: 'PerfilColaborador', element: <RedirectPerfilColaborador /> },
      { path: 'NuevoColaborador', element: <NuevoColaborador/> },
      { path: 'PerfilColaborador/:id', element: <IngresoColaborador /> },
      { path: 'Seguridad', element: <SeguridadMS /> },
      { path: 'Firma', element: <FirmaElectronica /> },
      { path: 'Seguridad/:id', element: <SeguridadShow /> },
    
      
      { path: 'Spinners', element: <Spinners /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default ThemeRoutes;
